import React from 'react';

interface Props<T extends Record<string, string> = Record<string, string>> {
  items: T
  defaultItem?: keyof T
  onChange?: (key: string) => void
}

const PageHeaderMenu: React.FC<Props> = ({
  items,
  defaultItem,
  onChange,
}) => {
  return (
    <div className="input-container input-container--select">
      <select
        className="form-inline"
        defaultValue={defaultItem}
        onChange={(e) => {
          if (onChange) {
            onChange(e.target.value);
          }
        }}
      >
        {Object.entries(items).map(([key, value]) => {
          return (
            <option key={`PageHeaderMenuItem-${key}`} value={key}>{value}</option>
          );
        })}
      </select>
    </div>
  );
};

export default PageHeaderMenu;
